module.exports = __webpack_public_path__ + "img/marketplace-animate.47c41113.svg";